<template>
  <div class="print" v-html="contract"></div>
</template>

<script>
  import { mapActions } from 'vuex';
  export default {
    name: 'Contract',
    data() {
      return {
        contract: '',
      }
    },
    methods: {
      ...mapActions(['getContract']),
    },
    mounted() {
      this.getContract(this.$route.params.id).then(response => {
        // this.contract = response.data.contract;

            // Open the print window
            const prtHtml = response.data.contract;
            const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinPrint.document.write(`<!DOCTYPE html>
          <html>
            <head>
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
            WinPrint.close();
        setTimeout(() => {
          window.print();
        }, 500);
      });
    }
  }
</script>

<style scoped>
  body {
    background: #fff !important;
  }
  .print {
    color: #000 !important;
    padding-top: 40px;
  }
  @media print{
    body{
      background: #fff !important;
    }
  }
</style>